module.exports = Marionette.ItemView.extend( {
	template: '#tmpl-qazana-panel-revisions-no-revisions',
	id: 'qazana-panel-revisions-no-revisions',
	className: 'qazana-panel-nerd-box'
} );
